module.exports = __webpack_public_path__ + "img/magento-banner.f433cf16.webp";